import clsx from 'clsx';
import React, {ReactNode, ReactElement} from 'react';
import {PressEventProvider, PressEventProps} from 'components/PressEventProvider';
import {Wrapper} from './style';

interface ButtonProps {
  fill?: boolean;
  color?: string;
  block?: boolean;
  inline?: boolean;
  disabled?: boolean;
  children?: ReactNode;
  onPress?: () => void;
}

export const Button = ({
  fill,
  color,
  block,
  inline,
  onPress,
  disabled,
  children,
}: ButtonProps): ReactElement => {
  const className = clsx({fill}, {block}, {inline}, {disabled}, {[color]: color});

  return (
    <PressEventProvider onPress={!disabled ? onPress : undefined}>
      {(props: PressEventProps) => (
        <Wrapper className={className} {...props}>
          {children}
        </Wrapper>
      )}
    </PressEventProvider>
  );
};

export {Compensator, SectionConstraints} from './style';
